module.exports = __webpack_public_path__ + "static/img/2.2432e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/2.png
// module id = Zg9N
// module chunks = 1